import React, { createContext, useContext, useState } from "react";

const OilContext = createContext(undefined);
export const OilProvider = ({
  children,
}) => {
    const [oils, setOils] = useState(null);
    return (
        <OilContext.Provider
        value={{
            oils,
            setOils,
        }}
        >
            {children}
        </OilContext.Provider>
    );
};
export const useOilContext = () => {
  const context = useContext(OilContext);
  if (!context) {
    throw new Error("useOilContext must be used within a OilProvider");
  }
  return context;
};